// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

/* eslint-disable no-console */

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
  console.log("Quick view loaded");
});
/* eslint-enable no-console */

document.addEventListener("DOMContentLoaded", function () {
  waitForProperty(angelinos, 'rechargeProducts', () => {
    //angelinos.updateButton();
    waitForProperty(angelinos, 'bundleCollectionProducts', () => {
      angelinos.update();
      angelinos.resourcesLoaded = true;
    });
  });  
});


/*
  1. In theme-globals.liquid need to set useUnminThemeJS = true
  2. In theme.js modify function addItemById(varId, quantity)
     Add: var data = angelinos.addItemById(varId, quantity);
     Comment Out: var data = {
                    items: [{
                    id: varId,
                    quantity: quantity
                    }]
                  };
*/

const angelinos = {
  debug: true,
  cacheExpirationType: 10 * 60 * 1000,
  rebuySmartCartEnabled: true,
  resourcesLoaded: false,
  sellingPlanUpdating: false,
  subscribeAndSave: localStorage.getItem('subscribeAndSave') === 'true',
  snsButton: "",
  snsFrequency: JSON.parse(localStorage.getItem('snsFrequency')) || { unit: 'once', count: 1, text: 'One-Time Shipment' },
  snsText1: "SUBSCRIBE & SAVE 5%",
  snsText2: "One-time Only",
  snsNote: "Now and on every future order. Cancel anytime!",
  snsFrequencies: [
    { unit: 'once', count: 1, text: 'One-Time Shipment' },
    { unit: 'month', count: 1, text: 'Every Month' },
    { unit: 'week', count: 6, text: 'Every 6 weeks' },
    { unit: 'month', count: 2, text: 'Every 2 Months' },
    { unit: 'week', count: 10, text: 'Every 10 weeks' },
    { unit: 'month', count: 3, text: 'Every 3 Months' },
    { unit: 'month', count: 4, text: 'Every 4 Months' },
  ],
  orderIntervalFrequency: 30,
  orderIntervalUnitType: "day",
  quickCartInstance: Shopify.theme.sections.instances.find(instance => instance.type === "quick-cart"),

  bundleCollectionHandle: 'bab',
  bundleProductId: '7609867042879',
  bundleProductHandle: 'buld-a-box',
  bundleVariantId: '41218899902527',
  bundleCollectionId: '275036340287',
  bundleCollectionProducts: null,
  bundleUniqueId: localStorage.getItem('bundleUniqueId'),
  customDashboard: true,
  rechargeProducts: null,
  discountLevels: [
    { products: 0, discount: 0.00 },
    { products: 1, discount: 0.00 },
    { products: 2, discount: 0.00 },
    { products: 3, discount: 0.00 },
    { products: 4, discount: 0.00 },
    { products: 5, discount: 7.76 },
    { products: 6, discount: 9.10 },
    { products: 7, discount: 14.78 },
    { products: 8, discount: 20.80 },
    { products: 9, discount: 21.07 },
    { products: 10, discount: 23.81 },
    { products: 11, discount: 24.28 },
    { products: 12, discount: 34.10 }
  ],

  init: async function () {
    this.accountOverview();
    this.cornerStone.init(this);
    this.rebuy.init(this);
    await this.initRechargeAPI();
    await this.initRecharge();
    await this.initShopify();
    this.customerPortal();
    //do we need expires for bundleCollectionId/bundleCollectionProducts
    this.bundleCollectionId = this.bundleCollectionId || (await this.fetchBundleCollection(this.bundleCollectionHandle)).id.toString();
    await this.observeCartChanges();
    await this.observeQuickProductModalChanges();
    await this.updateRechargeNavigations();

    document.addEventListener("click", e => {
        if (this.sellingPlanUpdating) {
            this.debug && console.log("clicks disabled while updating selling plan");
            e.stopPropagation();
            e.preventDefault();
        }
    }, true);
  },

  initRecharge: async function () {
    this.rechargeProducts = await this.getRechargeProducts();
  },

  initShopify: async function () {
    this.bundleCollectionProducts = this.bundleCollectionProducts || (await this.getBundleCollectionProducts());
  },

  getBundleCollectionProducts: async function () {
    // Ensure the cached namespace exists
    window.cached = window.cached || {};

    // Check if bundleCollectionProducts exists and hasn’t expired
    if (!window.cached.bundleCollectionProducts || window.cached.bundleCollectionProducts.data.products.length == 0 || (Date.now() - window.cached.bundleCollectionProducts.timestamp > this.cacheExpirationType)) {
      // Fetch new data if it doesn’t exist or has expired
      const response = await fetch(`/collections/${this.bundleCollectionHandle}/products.json?limit=250`);
      const collection = await response.json();
      window.cached.bundleCollectionProducts = {
        data: collection,
        timestamp: Date.now() // Set a new timestamp
      };
    }
    
    // Use the current bundleCollectionProducts data
    return window.cached.bundleCollectionProducts.data.products; 
  },

  getRechargeProducts: async function() {
    // Ensure the cached namespace exists
    window.cached = window.cached || {};
  
    // Check if rechargeProducts exists and hasn’t expired
    if (window.cached.rechargeProducts && window.cached.rechargeProducts.data.length > 0 && (Date.now() - window.cached.rechargeProducts.timestamp <= this.cacheExpirationType)) {
      // Return the cached data if it’s still valid
      return window.cached.rechargeProducts.data;
    }
  
    // Helper function to wait for ReChargeWidget to load
    const waitForReChargeWidget = () => {
      return new Promise(resolve => {
        const checkWidget = () => {
          if (window.ReChargeWidget && window.ReChargeWidget.api) {
            resolve();
          } else {
            setTimeout(checkWidget, 100); // Retry every 100ms
          }
        };
        checkWidget();
      });
    };
  
    // Wait until ReChargeWidget is loaded (only if cache is expired or doesn’t exist)
    await waitForReChargeWidget();
  
    // Fetch new data since cache was invalid or non-existent
    const products = await ReChargeWidget.api.fetchProducts();
    window.cached.rechargeProducts = {
      data: products,
      timestamp: Date.now() // Set a new timestamp
    };
  
    // Return the fetched data
    return window.cached.rechargeProducts.data;
  },

  accountOverview: async function () {
    //problem is on mobile it's dynamically inserting the dom elements
    const accountOverviewLinks = document.querySelectorAll(".account-overview .account-overview__links");
  
    if (accountOverviewLinks.length > 0) {
      accountOverviewLinks.forEach((linkContainer) => {
        const aManageSubscription = document.createElement("a"); 
        aManageSubscription.className = "account-overview__link fs-body-100 recharge-portal-access";
        aManageSubscription.href = "#";
        aManageSubscription.innerText = 'Manage Subscriptions';
        aManageSubscription.style.display = "none";
        
  
        const icon = document.createElement("span"); 
        icon.className = "icon icon-package-closed";
        const svg = document.createElement("svg"); 
        svg.setAttribute('viewBox', '-0.5 -0.5 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        
        icon.append(svg);
        aManageSubscription.prepend(icon);
        linkContainer.prepend(aManageSubscription);
      });
    }
  },

  rechargeLogin: async function () {
    if (!this.rechargeSession) {
      this.rechargeSession = await recharge.auth.loginShopifyAppProxy().catch(error => {
        console.error("Authentication failed:", error);
        throw error;
      });
    }
  },
  
  rechargeFetchPortalAccess: async function () {
    if (this.rechargeSession && this.rechargeSession.customerId != null) {
      //this.rechargePortalAccess = await recharge.customer.getCustomerPortalAccess(this.rechargeSession);
      this.rechargePortalAccess = await recharge.customer.getCustomerPortalAccess(this.rechargeSession, { page_destination: 'overview' });
    }
  },    

  rechargeGetSubscriptions: async function () {
    if (!this.rechargeSubscriptions && this.rechargeSession && this.rechargeSession.customerId != null) {
      //this.rechargeSubscriptions = (await recharge.subscription.listSubscriptions(this.rechargeSession, { limit: 250, sort_by: 'id-asc' })).subscriptions;
      await recharge.subscription.listSubscriptions(this.rechargeSession, {
        limit: 250,
        sort_by: 'id-asc'
        //status: 'Active',
        //include: 'bundle_product'
      }).catch(error => {
        console.error("Fetching subscriptions failed:", error);
        throw error;
      }).then(response => {
        this.rechargeSubscriptions = response.subscriptions;
      });
    }
  },    

  rechargeCheckActiveSubscriptions: async function() {
      await this.rechargeLogin();
      await this.rechargeGetSubscriptions();
      
      const hasActiveSubscriptions = this.rechargeSubscriptions?.some(subscription => subscription.status === "active");
  
      if (!hasActiveSubscriptions) {
          const style = document.createElement('style');
          style.innerHTML = `
              div.recharge-section-product-carousel {
                  display: none;
              }
          `;
          document.head.appendChild(style);
      }
  },

  initRechargeAPI: async function () {
      await this.rechargeLogin();
      await this.rechargeFetchPortalAccess();
      await this.rechargeGetSubscriptions();

      if (this.rechargePortalAccess && this.rechargeSubscriptions.length > 0) {
        var rechargePortalAccess = document.querySelectorAll('a.recharge-portal-access');
        
        rechargePortalAccess.forEach(access => {
          //access.href = this.rechargePortalAccess.portal_url.replace("/schedule", "/overview");
          if (this.rechargeSubscriptions.filter(subscription => subscription.status === "active").length == 0) {
            access.href = this.rechargePortalAccess.portal_url.replace("/overview?", "/subscriptions?")+"&tab=inactive";
            access.style.display = "block";
            access.innerHTML = "Reactivate Subscription";
          }
        });

        rechargePortalAccess = document.querySelectorAll('button.recharge-portal-access');
        
        rechargePortalAccess.forEach(access => {
          //access.addEventListener('click', () => {window.location.href = this.rechargePortalAccess.portal_url.replace("/schedule", "/overview");;});
          if (this.rechargeSubscriptions.filter(subscription => subscription.status === "active").length == 0) {
            access.addEventListener('click', () => {window.location.href = this.rechargePortalAccess.portal_url.replace("/overview?", "/subscriptions?")+"&tab=inactive";});
            access.disabled = false;
            access.innerHTML = "Reactivate Subscription";
          }
        });
      }
  },

  customerPortal: async function () {
    const customerAccountPage = document.querySelector(".customer.account.page");
    if (customerAccountPage) {
      this.debug && console.log("Customer Account Page");      
      const flexDiv = document.createElement("div"); 
      flexDiv.className = "customer--portal";

      const button0 = document.createElement("button");
      button0.type = "button";
      //button0.name = "sas";
      button0.className = "btn btn--primary";
      button0.setAttribute("aria-label", "SAS");    
      button0.textContent = "Shop Now";
      button0.addEventListener('click', () => {window.location.href = '/collections/build-a-box';});
      button0.disabled = false;

      const button1 = document.createElement("button");
      button1.type = "button";
      //button1.name = "sas";
      button1.className = "btn btn--primary recharge-portal-access";
      button1.setAttribute("aria-label", "SAS");    
      button1.textContent = "Manage Subscription";
      //button1.addEventListener('click', () => {window.location.href = '#';});
      button1.disabled = true;

      const button2 = document.createElement("button");
      button2.type = "button";
      //button2.name = "sas";
      button2.className = "btn btn--primary";
      button2.setAttribute("aria-label", "SAS");    
      button2.textContent = "ReShip Last Order";
      button2.addEventListener('click', () => this.reshipLastOrder());
      button2.disabled = (typeof lastOrder == 'undefined');

      const button3 = document.createElement("button");
      button3.type = "button";
      //button3.name = "sas";
      button3.className = "btn btn--primary";
      button3.setAttribute("aria-label", "SAS");    
      button3.textContent = "View Addresses";
      button3.addEventListener('click', () => {window.location.href = '/account/addresses';});

      const accountTop = customerAccountPage.querySelector(".account__top");

      if (accountTop) {
        accountTop.replaceChildren();
        flexDiv.append(button0);
        flexDiv.append(button1);
        flexDiv.append(button2);
        flexDiv.append(button3);
        accountTop.prepend(flexDiv);
        accountTop.style.display = "block";
      } else {
        //console.error('Element with ID "quick-cart__sas" not found in the DOM.');
      }
    }
  },

  update: function () {
    if (!this.sellingPlanUpdating) {
      this.updateProductForm(); 
      this.updateProductGrid();   
      this.checkSubscribeAndSave();
      this.updateButton();
    }
  },

  checkSubscribeAndSave: function () {
    this.debug && console.log("checkSubscribeAndSave", this.subscribeAndSave, this.getTotalQuantityWithSubscription());
    if (this.subscribeAndSave && this.getTotalQuantityWithSubscription() == 0) {
      this.removeSellingPlan();
      this.debug && console.log("Reset updateSubscribeAndSave");
    }
  },

  updateRechargeNavigations: function () {
    //document.querySelectorAll('a.recharge-navigation-orders').forEach(a => {
      //a.style.display = 'none';
      //a.setAttribute("href", "/account");
    //});      
  },  

  observeQuickCartChanges: function () {
    const quickCartWrapper = document.querySelector('.quick-cart__wrapper');
    
    const mutationCallback = (mutationsList) => { // Use an arrow function here
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const hasActiveClass = quickCartWrapper.classList.contains('active')
  
          if (hasActiveClass) {
            this.debug && console.log('The quick cart is active!');
          }
        }
      }
    };
  
    const observer = new MutationObserver(mutationCallback);
    observer.observe(quickCartWrapper, { attributes: true });
  },  
  
  observeQuickProductModalChanges: function () {
    const quickProductModal = document.querySelector('.quick-product-modal');
    
    const mutationCallback = (mutationsList) => { // Use an arrow function here
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const hasActiveClass = quickProductModal.classList.contains('active');
          const isVisibleClass = quickProductModal.classList.contains('is-visible');
  
          if (hasActiveClass && isVisibleClass) {
            //this.quickCartFooter();   // Now 'this' refers to your object instance
            this.update(); 
            this.debug && console.log('The modal is active and visible!');
          }
        }
      }
    };
  
    const observer = new MutationObserver(mutationCallback);
    observer.observe(quickProductModal, { attributes: true });
  },
   
  observeCartChanges: async function () {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          //this.quickCartFooter();
          if (this.resourcesLoaded) {
            this.update();
          }
          this.debug && console.log("observeCartChanges changes");
        }        
       
        const isCartLoadRequest = /\/cart.js/.test(entry.name);        
        if (isValidRequestType && isCartLoadRequest) {
          //this.quickCartFooter();
          if (this.resourcesLoaded) {
            this.update();
          }
          this.debug && console.log("observeCartChanges load");
        }        
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  },

  generateRandomString: function (length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
  },

  getRCBundleProperties: function () {
    this.bundleUniqueId = this.bundleUniqueId || this.generateRandomString(9);

    return {
      "_rc_bundle": `${this.bundleUniqueId}:${this.bundleProductId}`,
      "_rc_bundle_parent": this.bundleProductHandle,
      "_rc_bundle_variant": this.bundleVariantId,
      "_rc_bundle_collection_id": this.bundleCollectionId
    };
  },

  fetchBundleCollection: async function (handle) {
    const response = await fetch(`/collections/${handle}.json`);
    const collection = await response.json();
    return collection.collection;
  },

  addSellingPlan: async function (selectedFrequency) {
    localStorage.setItem('snsFrequency', JSON.stringify({ unit: selectedFrequency.unit, count: selectedFrequency.count }));
    this.snsFrequency = { unit: selectedFrequency.unit, count: selectedFrequency.count };
  
    const button = document.querySelector('#quick-cart__sas button');
    const onetime = document.querySelector('#quick-cart__sas #frequencyDropdown');
    const checkout = document.querySelector(this.snsButton);
    
    button.disabled = true;
    onetime.disabled = true;
    checkout.disabled = true;
  
    try {
      this.sellingPlanUpdating = true;
  
      // Fetch the latest cart
      let cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await cartResponse.json();
  
      // Fetch products from ReCharge API
      //const rechargeProducts = await ReChargeWidget.api.fetchProducts();
      const rechargeProducts = await this.getRechargeProducts();
  
      // Fetch products in the bundle collection
      //const bundleCollectionProducts = await this.fetchBundleCollectionProducts(this.bundleCollectionHandle);
      const bundleCollectionProducts = this.bundleCollectionProducts || (await getBundleCollectionProducts());
  
      // Prepare items to add in bulk
      const itemsToAdd = [];
      const nonSubscriptionItems = []; // Items without a selling plan
  
      for (let index = 0; index < cart.items.length; index++) {
        const item = cart.items[index];
  
        // Check if the product exists in the bundle collection
        const isProductInBundleCollection = bundleCollectionProducts.some(product => product.id === item.product_id);
  
        // Check if the product exists in recharge
        const matchingProduct = rechargeProducts.find(product => product[item.product_id]);
  
        if (matchingProduct) {
          const productId = item.product_id;
          const productDetails = matchingProduct[productId];
          let sellingPlanId = null;
          let sellingPlanGroupId = null;
  
          for (const group of productDetails.selling_plan_groups) {
            const sellingPlan = group.selling_plans.find(plan =>
              plan.order_interval_unit_type === this.snsFrequency.unit &&
              plan.order_interval_frequency === this.snsFrequency.count
            );
  
            if (sellingPlan) {
              sellingPlanId = sellingPlan.selling_plan_id;
              sellingPlanGroupId = group.selling_plan_group_id;
              break;
            }
          }
  
          if (sellingPlanId && sellingPlanGroupId) {
            const variantExists = productDetails.variants.some(variant =>
              variant.id === item.variant_id &&
              variant.selling_plan_allocations.some(allocation => allocation.selling_plan_id === sellingPlanId.toString())
            );
  
            if (variantExists) {
              const properties = isProductInBundleCollection ? this.getRCBundleProperties() : {};
  
              // Add item with selling plan to the bulk add array
              itemsToAdd.push({
                id: item.variant_id,
                quantity: item.quantity,
                selling_plan: sellingPlanId,
                properties: properties
              });
            } else {
              this.debug && console.log(`No matching variant found for item ${item.id} with selling plan ${sellingPlanId}`);
            }
          } else {
            nonSubscriptionItems.push({
              id: item.variant_id,
              quantity: item.quantity
            });
            this.debug && console.log(`No matching selling plan group found for item ${item.id}`);
          }
        } else {
          // Add non-subscription item to the nonSubscriptionItems array
          nonSubscriptionItems.push({
            id: item.variant_id,
            quantity: item.quantity
          });
          this.debug && console.log(`Product ${item.product_id} is not in the bundle collection or does not have a selling plan`);
        }
      }
  
      // Combine subscription and non-subscription items
      const allItemsToAdd = [...itemsToAdd, ...nonSubscriptionItems];
  
      if (allItemsToAdd.length > 0) {
        // Clear the cart first
        await fetch(window.Shopify.routes.root + 'cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        });
  
        // Add all items in one go
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: allItemsToAdd })
        });
  
        this.debug && console.log("All items added back to cart");
      }
  
      cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      theme.cartData = await cartResponse.json();
  
      localStorage.setItem('bundleUniqueId', this.bundleUniqueId);
      this.updateSubscribeAndSave(true);
      this.update();
  
      this.debug && console.log("All items processed and added back to cart.");
    } catch (error) {
      console.error("Error adding items to cart:", error);
    } finally {
      this.sellingPlanUpdating = false;
      this.refreshCart();
      button.disabled = false;
      onetime.disabled = false;
      checkout.disabled = false;
    }
  },

  confirmSellingPlan: async function () {
    // Create modal HTML
    let modalHTML = `
        <div id="subscription-modal" class="subscription-modal">
            <div class="subscription-modal-content">
                <span class="close">&times;</span>
                <h2>CHOOSE YOUR FREQUENCY</h2>
                <p>Save 5% on all recurring orders!<br>Edit, skip, cancel anytime.</p>
                <select id="frequency-select" class="frequency">`
    
    this.snsFrequencies.forEach(optionData => {
      const value = JSON.stringify({ unit: optionData.unit, count: optionData.count });
      const text = optionData.text;
      if (text != "One-Time Shipment") {
        modalHTML = modalHTML + `<option value='${value}'>${text}</option>`
      }
    });
    
    modalHTML = modalHTML + `</select>
                <div class="subscription-buttons">
                    <button id="confirm-subscription" class="confirm-subscription">CONFIRM SUBSCRIPTION</button>
                    <button id="cancel-subscription" class="cancel-subscription">CANCEL</button>
                </div>
            </div>
        </div>
    `;

    // Insert modal into document
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const modal = document.getElementById('subscription-modal');
    const closeBtn = modal.querySelector('.close');
    const confirmBtn = document.getElementById('confirm-subscription');
    const cancelBtn = document.getElementById('cancel-subscription');
    //const subscribeButton = document.querySelector('button[name="sas"]');
    const rebuyCart = document.getElementById('rebuy-cart');

    // Show modal and hide rebuy-cart
    //if (subscribeButton) {
    //    subscribeButton.addEventListener('click', function(e) {
    //        e.preventDefault();
    //        e.stopPropagation();
            modal.style.display = 'block';
            modal.style.visibility = "visible";
            if (rebuyCart) {
                rebuyCart.style.display = 'none';
            }
            document.body.style.overflow = 'hidden';
    //    });
    //}

    // Close modal function
    function closeModal() {
        if (modal) {
            modal.parentElement.removeChild(modal);
        }
        if (rebuyCart) {
            rebuyCart.style.display = 'block';
        }
        document.body.style.overflow = 'auto';
    }

    // Event listeners for closing modal
    closeBtn.addEventListener('click', closeModal);
    cancelBtn.addEventListener('click', closeModal);
    confirmBtn.addEventListener('click', function() {
        const selectedFrequency = JSON.parse(document.getElementById('frequency-select').value);
        this.debug && console.log('Selected frequency:', selectedFrequency.unit, selectedFrequency.count);
        angelinos.addSellingPlan(selectedFrequency);
        closeModal();
    });
    
    // Close modal if clicking outside
    window.addEventListener('click', function(event) {
        if (event.target === modal) {
            closeModal();
        }
    });
  },

  changeSellingPlan: async function(selectedFrequency) {
    this.debug && console.log('Selected frequency:', selectedFrequency.unit, selectedFrequency.count);
  
    // Check if the selected frequency is "once"
    if (selectedFrequency.unit === 'once') {
      // Call the function to remove the selling plan
      localStorage.setItem('snsFrequency', JSON.stringify({ unit: 'once', count: 1, text: 'One-Time Shipment' }));
      this.snsFrequency = { unit: 'once', count: 1, text: 'One-Time Shipment' };
      this.removeSellingPlan();
    } else {
      // Call the function to add the selling plan or handle other frequencies
      //this.addSellingPlan(selectedFrequency);
      this.addSellingPlan(selectedFrequency);
    }
  },

  removeSellingPlan: async function() {
    const button = document.querySelector('#quick-cart__sas button');
    const onetime = document.querySelector('#quick-cart__sas #frequencyDropdown');
    const checkout = document.querySelector(this.snsButton);

    this.debug && console.log("button", button);
    this.debug && console.log("onetime", button);
    this.debug && console.log("checkout", button);
    button.disabled = true;
    onetime.disabled = true;
    checkout.disabled = true;
  
    try {
      this.sellingPlanUpdating = true;
  
      // Fetch the latest cart using the correct URL
      let cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await cartResponse.json();
  
      // Prepare items for bulk add
      const itemsToAdd = [];
  
      // Iterate over cart items and update selling plan to null
      for (let index = 0; index < cart.items.length; index++) {
        const item = cart.items[index];
        let updatedProperties = { ...item.properties };
  
        // Remove any property that starts with "_rc_bundle"
        for (const key in updatedProperties) {
          if (key.startsWith("_rc_bundle")) {
            delete updatedProperties[key];
          }
        }
  
        // Check if item has a selling plan to remove
        if (item.selling_plan_allocation !== undefined && item.selling_plan_allocation !== null) {
          this.debug && console.log(item.id, item.selling_plan_allocation);
  
          // Prepare the item without selling plan
          itemsToAdd.push({
            id: item.variant_id,
            quantity: item.quantity,
            selling_plan: null,
            properties: updatedProperties
          });
        } else {
          // If no selling plan, add item as is
          itemsToAdd.push({
            id: item.variant_id,
            quantity: item.quantity,
            properties: updatedProperties
          });
        }
      }
  
      if (itemsToAdd.length > 0) {
        // Clear the cart first
        await fetch(window.Shopify.routes.root + 'cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        });
  
        // Add all items back in bulk without selling plans
        const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: itemsToAdd })
        });
  
        const addResult = await addResponse.json();
        this.debug && console.log("All items added back to cart without selling plans:", addResult);
      }
  
      cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      theme.cartData = await cartResponse.json();
  
      this.bundleUniqueId = null;
      localStorage.removeItem('bundleUniqueId');
      this.updateSubscribeAndSave(false);
      this.update();
  
      this.debug && console.log("All applicable selling plans removed from cart items.");
    } catch (error) {
      console.error("Error removing selling plans:", error);
    } finally {
      this.sellingPlanUpdating = false;
      this.refreshCart();
      button.disabled = false;
      onetime.disabled = false;
      checkout.disabled = false;
    }
  },
  
  updateSubscribeAndSave: async function (value) {
    if (this.subscribeAndSave !== value) {
      this.subscribeAndSave = value;
      localStorage.setItem('subscribeAndSave', value);
      this.updateButton();
    }
  },

  updateButton: async function () {
    this.debug && console.log("updateButton");

    const button = document.createElement("button");
    button.type = "button";
    button.name = "sas";
    
    if (this.rebuySmartCartEnabled) {
      button.className = "rebuy-button block";
    }
    else
    {
      button.className = "btn btn--full btn--primary";
      button.setAttribute("aria-label", "SAS");
    }

    const onetime = document.createElement("div");
    onetime.className = "custom-button btn btn--full btn--primary";

    const spanFrequency = document.createElement('span');
    spanFrequency.innerHTML = 'Discount applied!<br>Choose Your Frequency:';

    const selectFrequncy = document.createElement('select');
    selectFrequncy.id = "frequencyDropdown";
    selectFrequncy.addEventListener('change', (event) => {
      // Get the selected value and parse it
      const selectedValue = JSON.parse(event.target.value);
      
      // Call the changeSellingPlan function and pass the parsed value
      this.changeSellingPlan(selectedValue);
    });
    
    this.snsFrequencies.forEach(optionData => {
      const option = document.createElement('option');
      option.value = JSON.stringify({ unit: optionData.unit, count: optionData.count });
      option.textContent = optionData.text;

      if (option.value === JSON.stringify({ unit: this.snsFrequency.unit, count: this.snsFrequency.count })) {
        option.selected = true; // Mark the option as selected
      }
      
      selectFrequncy.appendChild(option);
    });
    
    // Append the span and select to the main div
    onetime.appendChild(spanFrequency);
    onetime.appendChild(selectFrequncy);

    //const p = document.createElement("p");
    let p;
      if (this.rebuySmartCartEnabled) {
        p = document.createElement("span");
        p.className = "note white ff-body fs-body-60 t-subduedy";
      }
    else
      {
        p = document.createElement("p");
        p.className = "note ff-body fs-body-75 t-subduedy";
      }

    if (this.subscribeAndSave == true) {
      //button.textContent = this.snsText2;
      //button.addEventListener('click', () => this.removeSellingPlan());
      button.style.display = "none";
      p.textContent = "";
      p.style.visibility = "hidden";
      //onetime.style.display = "block";
    } else {
      const totalQuantityQualifySubscription = await this.getTotalQuantityQualifySubscription();
      
      this.debug && console.log("updateButton", totalQuantityQualifySubscription);    
      button.textContent = this.snsText1;
      button.addEventListener('click', () => this.confirmSellingPlan());
      if (this.rebuySmartCartEnabled) {
        button.style.display = totalQuantityQualifySubscription > 0 ? "block" : "none";
      }
      else {
        button.style.visibility = totalQuantityQualifySubscription > 0 ? "visible" : "hidden";
      }        
      p.textContent = this.snsNote;      
      if (this.rebuySmartCartEnabled) {
        p.style.display = totalQuantityQualifySubscription > 0 ? "block" : "none";
      }
      else {
        p.style.visibility = totalQuantityQualifySubscription > 0 ? "visible" : "hidden";
      }        
      onetime.style.display = "none";
    }

    const spanElement = document.getElementById("quick-cart__sas");

    // Check if spanElement exists before manipulating it
    if (spanElement) {
      while (spanElement.firstChild) {
        spanElement.removeChild(spanElement.firstChild);
      }
  
      if (this.rebuySmartCartEnabled) {
        //spanElement.appendChild(p);
        button.appendChild(p);
      }
      spanElement.appendChild(onetime);
      spanElement.appendChild(button);
      if (!this.rebuySmartCartEnabled) {
        spanElement.appendChild(p);
      }
    } else {
      //console.error('Element with ID "quick-cart__sas" not found in the DOM.');
    }
    
    this.updateDiscountGoal();
  },

  updateDiscountGoal: async function () {
    this.debug && console.log("updateDiscountGoal");

    if (this.rebuySmartCartEnabled) {
      var addBox = 1;
      if (this.getTotalQuantityQualifyBuildABoxDiscount()>0 && this.getTotalQuantityQualifyBuildABoxDiscount()<4)
      {
        addBox = 5-this.getTotalQuantityQualifyBuildABoxDiscount();
      }
      var discountPercentageCurrent = this.getDiscountLevel(0);
      var discountPercentageNext = this.getDiscountLevel(addBox);

      const div = document.createElement("div");
      div.className = "dashed-pill";

      const span1 = document.createElement("span");
      span1.className = "action";
      span1.innerHTML = `ADD ${addBox} MORE`;

      const pSpan1 = document.createElement("p");
      pSpan1.textContent = "ELIGIBLE BOX OR BAG";
      span1.appendChild(pSpan1);
      
      const span2 = document.createElement("span");
      span2.className = "saving";
      span2.innerHTML = `SAVE ${discountPercentageNext.toFixed(2)}%`;

      const p = document.createElement("p");
      p.className = "disclaimer";
      p.textContent = "Discount applied automatically.";

      div.appendChild(span1);
      div.appendChild(span2);

      const spanElement = document.getElementById("quick-cart__goal");

      if (spanElement) {
        while (spanElement.firstChild) {
          spanElement.removeChild(spanElement.firstChild);
        }

        if (discountPercentageCurrent != discountPercentageNext)
        {
          spanElement.appendChild(div);
          spanElement.appendChild(p);
          spanElement.style.display = "flex";
        }
        else
        {
          spanElement.style.display = "none";          
        }          
      }    
    }
  },

  updateProductForm: async function() {
    /* Enhancedments
      can we move const properties = await this.getRCBundleProperties() somewhere else to optimize/consolidate?
      PDP lower sticky bar has add to cart not working properly
    */
    const productForms = document.querySelectorAll("form.product-form");
  
    const promises = Array.from(productForms).map(async (productForm) => {
      const variantId = productForm.querySelector("select[name='id']") ? Number(productForm.querySelector("select[name='id']").value) : Number(productForm.getAttribute("data-current-product-id"));
      const productId = Number(productForm.querySelector("input[name='product-id']").value);
      const currentProductId =  Number(productForm.getAttribute("data-current-product-id"));

      const variantPrice = await this.getVariantPrice(variantId, productId);

      this.debug && console.log("variantId", variantId);
      this.debug && console.log("productId", productId);
      this.debug && console.log("variantPrice", variantPrice);
  
      const productBlocks = document.querySelectorAll('div.product__block.product__block--product-header');
      const blocksWithSpecificVariant = Array.from(productBlocks).filter(block =>
        block.querySelector(`div[variant-id="${variantId}"]`)
      );

      const properties = this.getRCBundleProperties();
      const propertiesArray = Object.entries(properties);

      blocksWithSpecificVariant.forEach(block => {
        if (variantPrice.price > 0) {
          if (variantPrice.sellingPlanId) {
            let hiddenInput = productForm.querySelector("input[name='selling_plan']");
            if (hiddenInput) {
              hiddenInput.value = variantPrice.sellingPlanId;
            } else {
              hiddenInput = document.createElement("input");
              hiddenInput.type = "hidden";
              hiddenInput.name = "selling_plan";
              hiddenInput.value = variantPrice.sellingPlanId;
              productForm.appendChild(hiddenInput);
            }

            if (variantPrice.isProductInBundleCollection) {
              propertiesArray.forEach(([key, value]) => {
                let propertyInput = productForm.querySelector(`input[name='properties[${key}]']`);
                if (propertyInput) {
                  propertyInput.value = value;
                } else {
                  propertyInput = document.createElement("input");
                  propertyInput.type = "hidden";
                  propertyInput.name = `properties[${key}]`;
                  propertyInput.value = value;
                  productForm.appendChild(propertyInput);
                }
                //console.log(key, value);
              });
            }
          } else {
            let hiddenInput = productForm.querySelector("input[name='selling_plan']");
            if (hiddenInput) {
              productForm.removeChild(hiddenInput);
            }

            propertiesArray.forEach(([key, value]) => {
              let propertyInput = productForm.querySelector(`input[name='properties[${key}]']`);
              if (propertyInput) {
                productForm.removeChild(propertyInput);
              }
            });
          }
          
          block.querySelectorAll("s[data-compare-price]").forEach(compareSpan => {
            if (variantPrice.comparePrice > variantPrice.price) {
              compareSpan.innerHTML = `$${variantPrice.comparePrice.toFixed(2)}`;
            } else {
              if (variantPrice.isProductInBundleCollection) {
                compareSpan.innerHTML = ``;
              }
            }
          });

          block.querySelectorAll("span[data-price]").forEach(priceSpan => {
            priceSpan.innerHTML = `$${variantPrice.price.toFixed(2)}`;
          });

          block.querySelectorAll("span[data-has-discount]").forEach(discountSpan => {
            if (variantPrice.discountPercentage) {
              discountSpan.setAttribute("data-has-discount", "true");
              discountSpan.querySelector("span.displayed-discount").innerHTML = `${variantPrice.discountPercentage.toFixed(2)}% off`;
            } else {
              if (variantPrice.isProductInBundleCollection) {
                discountSpan.setAttribute("data-has-discount", "false");
              }
            }
          });
        }
      });

      if (variantPrice.price > 0) {
        const sticky_atc_block = document.querySelector(`form[data-current-product-id="${currentProductId}"]`);
  
        sticky_atc_block.querySelectorAll("s[data-compare-price]").forEach(compareSpan => {
          if (variantPrice.comparePrice > variantPrice.price) {
            compareSpan.innerHTML = `$${variantPrice.comparePrice.toFixed(2)}`;
          } else {
            compareSpan.innerHTML = ``;
          }
        });
  
        sticky_atc_block.querySelectorAll("span[data-price]").forEach(priceSpan => {
          priceSpan.innerHTML = `$${variantPrice.price.toFixed(2)}`;
        });      
      }
    });

    const productForm = productForms[0];
    const variantId = productForm.querySelector("select[name='id']") ? Number(productForm.querySelector("select[name='id']").value) : Number(productForm.getAttribute("data-current-product-id"));
    const productId = Number(productForm.querySelector("input[name='product-id']").value);
    const variantPrice = await this.getVariantPrice(variantId, productId);

    if (variantPrice?.isProductInBundleCollection) {
      // --- 1. CONFIGURATION ---
      var currentQty = this.getTotalQuantityQualifyBuildABoxDiscount();
      var startTier = 5;  // Discount starts here
      var maxTier = 12;   // Discount maxes out here
      var currentDiscount = this.getDiscountLevel(0); // Current savings
      
      // --- 2. CALCULATE THE "MICRO-GOAL" ---
      // We want to find the next immediate step that gives a reward.
      
      var quantityNeeded = 1;
      var nextDiscount = 0;
      
      if (currentQty < startTier) {
        // Phase 1: Not qualified yet? Goal is getting to 5.
        quantityNeeded = startTier - currentQty;
        nextDiscount = this.getDiscountLevel(quantityNeeded); // This might need adjustment based on how your function works
      } else if (currentQty < maxTier) {
        // Phase 2: Already qualified. Find next jump.
        // We look ahead: Does adding 1 box increase the %? If not, try 2, then 3...
        var checkQty = 1;
        // Safety loop: Find next discount bump, stop at maxTier
        while ((currentQty + checkQty) <= maxTier) {
          var tempNextDiscount = this.getDiscountLevel(checkQty); // Check potential discount
          // Note: Assuming getDiscountLevel takes "items to add" or "total items". 
          // If it takes "items to add", use checkQty. If "total", use currentQty + checkQty.
          // Based on your original code: this.getDiscountLevel(addBox), it likely takes "items to add".
          
          if (tempNextDiscount > currentDiscount) {
            quantityNeeded = checkQty;
            nextDiscount = tempNextDiscount;
            break;
          }
          checkQty++;
          
          // If we hit the max and no jump found, just default to 1 (incremental)
          if ((currentQty + checkQty) > maxTier) {
            quantityNeeded = 1;
            nextDiscount = this.getDiscountLevel(1);
          }
        }
      } else {
        // Maxed out
        quantityNeeded = 0;
      }

      // --- 3. VISUALS ---
      // We map the bar to 12 so they can see they are "filling up" their savings capacity.
      var visualGoal = maxTier; 
      var progressPercent = (currentQty / visualGoal) * 100;

      // Visual Cleanups
      if (progressPercent > 100) progressPercent = 100; 
      if (currentQty > 0 && progressPercent < 15) progressPercent = 15;

      // --- 4. CREATE DOM ---
      const container = document.createElement("div");
      container.className = "goal-tracker-container";
      
      const textRow = document.createElement("div");
      textRow.className = "goal-text-row";
      
      let msgHTML = "";
      
      if (currentQty < maxTier) {
          // INCREMENTAL MESSAGING: "Add 1 more"
          // We do not mention "12". We only mention the immediate reward.
          msgHTML = `Add <b>${quantityNeeded} more</b> to reach <b style="color:#b12e2e">${nextDiscount.toFixed(2)}% OFF</b>`;
      } else {
          msgHTML = `<b style="color:#b12e2e">MAX DISCOUNT UNLOCKED! 🎉</b>`;
      }

      const msgMain = document.createElement("span");
      msgMain.innerHTML = msgHTML;
      textRow.appendChild(msgMain);

      // Bar Container
      const barBackground = document.createElement("div");
      barBackground.className = "progress-bar-bg";
      
      // The Fill
      const barFill = document.createElement("div");
      barFill.className = "progress-bar-fill";
      barFill.style.width = `${progressPercent}%`;
      
      // Icon at the tip of the fill
      const icon = document.createElement("span");
      icon.className = "progress-icon";
      icon.innerHTML = (currentQty >= maxTier) ? "⭐" : "☕"; 
      barFill.appendChild(icon);
      
      // NEW: The "Max Goal" Flag at the far right
      // This satisfies curiosity without making it the "Main Goal"
      // Assuming you can get the max discount %:
      // var maxPercent = this.getDiscountLevel(maxTier - currentQty); // or hardcode if known
      // For safety, let's just use a text label or fetch logic if available.
      const maxLabel = document.createElement("span");
      maxLabel.className = "max-goal-label";
      maxLabel.innerHTML = "Max Savings"; // Or put "Max 20%" if you know the number
      
      barBackground.appendChild(barFill);
      barBackground.appendChild(maxLabel); // Append label to background

      // Subtext
      const subText = document.createElement("p");
      subText.className = "goal-subtext";
      if (currentQty < startTier) {
        subText.innerHTML = "Reach 5 boxes to unlock first discount.";
      } else if (currentQty < maxTier) {
        subText.innerHTML = "Discounts increase as you add more.";
      } else {
        subText.innerHTML = "You have the best possible price!";
      }

      container.appendChild(textRow);
      container.appendChild(barBackground);
      container.appendChild(subText);

      // --- 5. INJECT ---
      const spanElement = document.getElementById("pdp__goal");

      if (spanElement) {
        while (spanElement.firstChild) {
          spanElement.removeChild(spanElement.firstChild);
        }
        // Always show unless there is absolutely no discount program active
        if (true) {
          spanElement.appendChild(container);
          spanElement.style.display = "block"; 
        }         
      }
    }

    await Promise.all(promises);
  },

  updateProductGrid: async function () {
    const productItems = document.querySelectorAll("div.product-item");

    const promises = Array.from(productItems).map(async (productItem) => {
      const variantId = Number(productItem.getAttribute("data-variant-id"));
      const productId = Number(productItem.getAttribute("data-id"));
      const spanItemPrices = productItem.querySelectorAll("span.product-item__price-main");
  
      try {
        const variantPrice = await this.getVariantPrice(variantId, productId);

        if (variantPrice.price > 0) {
          spanItemPrices.forEach((spanItemPrice) => {
            if (variantPrice.comparePrice > variantPrice.price) {
              spanItemPrice.innerHTML = `<span class="visually-hidden">Regular price</span><s class="t-subdued">$${variantPrice.comparePrice.toFixed(2)}</s> <span class="sale" data-price="">$${variantPrice.price.toFixed(2)}</span>`;
            } else {
              spanItemPrice.innerHTML = `$${variantPrice.price.toFixed(2)}`;
            }
          });
        }
      } catch (error) {
        console.error("Error updating product item:", error);
      }
    });
    await Promise.all(promises);
  },

  getVariantPrice: async function (variantId, productId) {
    const variantPrice = {
      comparePrice: 0.00,
      price: 0.00,
      discountPercentage: 0.00,      
      sellingPlanId: null,
      isProductInBundleCollection: false,
      message: "",
      rawPrice: 0.00
    };

    this.bundleCollectionProducts = this.bundleCollectionProducts || (await this.getBundleCollectionProducts());

    variantPrice.isProductInBundleCollection = this.bundleCollectionProducts.some(product => product.id === productId);

    const product = this.bundleCollectionProducts.find(product => 
      product.variants.some(variant => variant.id === variantId)
    );

    if (this.subscribeAndSave) {
      //this.rechargeProducts = this.rechargeProducts || (await ReChargeWidget.api.fetchProducts());
      this.rechargeProducts = this.rechargeProducts || (await this.getRechargeProducts());

      const matchingProduct = this.rechargeProducts.find(product => product[productId]);

      let sellingPlanId = null;
      let unitPrice = 0.00;
      let discountPrice = 0.00;      

      if (matchingProduct) {
        const productDetails = matchingProduct[productId];

        for (const group of productDetails.selling_plan_groups) {
          const sellingPlan = group.selling_plans.find(plan =>
            //plan.order_interval_unit_type === this.orderIntervalUnitType &&
            //plan.order_interval_frequency === this.orderIntervalFrequency
            plan.order_interval_unit_type === this.snsFrequency.unit &&
            plan.order_interval_frequency === this.snsFrequency.count
          );
          if (sellingPlan) {
            sellingPlanId = sellingPlan.selling_plan_id;
            break;
          }
        }

        if (sellingPlanId) {
          const variantExists = productDetails.variants.some(variant =>
            variant.id.toString() === variantId.toString() &&
            variant.selling_plan_allocations.some(allocation => allocation.selling_plan_id === sellingPlanId.toString())
          );          

          if (variantExists) {
            const variantData = productDetails.variants.find(variant => variant.id.toString() === variantId.toString());
            const sellingPlanData = variantData.selling_plan_allocations.find(allocation => allocation.selling_plan_id === sellingPlanId.toString());
            
            variantPrice.sellingPlanId = sellingPlanId
            unitPrice = parseFloat(variantData.prices.unit_price);
            discountPrice = parseFloat(sellingPlanData.discounted_price);
          }
        }
      }
     
      if (product && product.tags.includes('bab')) {
        //discountPrice = discountPrice * (100.00 - this.getDiscountLevelForItem(variantId)) / 100.00;
        discountPrice = Math.ceil(discountPrice * (100.00 - this.getDiscountLevelForItem(variantId)) / 100.00 * 100) / 100;

        variantPrice.message = 'BAB SNS';
      } else {
        variantPrice.message = 'SNS';
      }      

      variantPrice.comparePrice = Math.round((parseFloat(unitPrice) || 0.00) * 100) / 100;
      variantPrice.price = Math.round((parseFloat(discountPrice) || 0.00) * 100) / 100;
      variantPrice.rawPrice = (((parseFloat(discountPrice) || 0.00) * 100) / 100) || variantPrice.price;
    } else {
      if (product && product.tags.includes('bab')) {
        const unitPrice = this.bundleCollectionProducts.reduce((price, product) => price ?? product.variants.find(variant => variant.id === variantId)?.price, null);
        //const discountPrice = parseFloat((unitPrice * (100.00-this.getDiscountLevelForItem(variantId)) / 100.00).toFixed(2));
        const discountPrice = Math.ceil(unitPrice * (100 - this.getDiscountLevelForItem(variantId)) / 100 * 100) / 100;
        const rawPrice = (unitPrice * (100 - this.getDiscountLevelForItem(variantId)) / 100 * 100) / 100;

        variantPrice.comparePrice = parseFloat(unitPrice) || 0.00;
        variantPrice.price = parseFloat(discountPrice) || 0.00;
        variantPrice.rawPrice = parseFloat(rawPrice) || price;
        variantPrice.message = 'BAB';
      } else {
        let unitPrice = 0;
        let discountPrice = 0;
        //this.rechargeProducts = this.rechargeProducts || (await ReChargeWidget.api.fetchProducts());
        this.rechargeProducts = this.rechargeProducts || (await this.getRechargeProducts());
        
        const matchingProduct = this.rechargeProducts.find(product => product[productId]);

        if (matchingProduct) {
          const productDetails = matchingProduct[productId];
          const variantExists = productDetails.variants.some(variant =>
            variant.id.toString() === variantId.toString()
          );          

          if (variantExists) {
            const variantData = productDetails.variants.find(variant => variant.id.toString() === variantId.toString());
            unitPrice = parseFloat(variantData.prices.unit_price);
            discountPrice = parseFloat(variantData.prices.unit_price);
          }
        }

        variantPrice.comparePrice = parseFloat(unitPrice) || 0.00;
        variantPrice.price = parseFloat(discountPrice) || 0.00;
        variantPrice.rawPrice = parseFloat(discountPrice) || 0.00;
        variantPrice.message = 'LIMITED';
      }      
    }   

    try {
      const discountPercentage = isFinite((variantPrice.comparePrice - variantPrice.rawPrice) / variantPrice.comparePrice * 100)
          ? Math.round(((variantPrice.comparePrice - variantPrice.rawPrice) / variantPrice.comparePrice) * 100 * 100) / 100
          : 0;
      
      variantPrice.discountPercentage = discountPercentage;
    } catch (error) {
      console.error('Error calculating discount:', error);
    }

    //console.log("variantPrice", variantPrice);
    return variantPrice;
  },

  addItemById: function(variantId, quantity) {
    var data = {
      items: [{
        id: variantId,
        quantity: quantity
      }]
    };

    if (this.subscribeAndSave) {
      const productId = this.getProductIdFromVariantId(variantId);

      const sellingPlanId = this.getVariantSellingPlanId(productId, variantId);
      
      if (sellingPlanId) {
        data.items[0].selling_plan = sellingPlanId;
      }

      const isProductInBundleCollection = this.bundleCollectionProducts.some(product => product.id === productId);

      if (isProductInBundleCollection) {
        const properties = this.getRCBundleProperties();
        data.items[0].properties = properties;
      }
    }    

    return data;
  },

  getProductIdFromVariantId: function (variantId) {
    variantId = Number(variantId);

    const product = this.bundleCollectionProducts.find(product => 
      product.variants.some(variant => variant.id === variantId)
    );    

    return product ? product.id : this.findProductIdWithVariantId(variantId);    
  },
  
  getVariantSellingPlanId: function (productId, variantId) {
    productId = Number(productId);
    variantId = Number(variantId);
    
    const matchingProduct = this.rechargeProducts.find(product => product[productId]);

    if (matchingProduct) {
      const productDetails = matchingProduct[productId];

      for (const group of productDetails.selling_plan_groups) {
        const sellingPlan = group.selling_plans.find(plan =>
          //plan.order_interval_unit_type === this.orderIntervalUnitType &&
          //plan.order_interval_frequency === this.orderIntervalFrequency
          plan.order_interval_unit_type === this.snsFrequency.unit &&
          plan.order_interval_frequency === this.snsFrequency.count
        );
        
        if (sellingPlan) {
          const sellingPlanId = sellingPlan.selling_plan_id;
          
          const variantExists = productDetails.variants.some(variant =>
            variant.id === variantId &&
            variant.selling_plan_allocations.some(allocation => allocation.selling_plan_id === sellingPlanId.toString())
          );          
  
          if (variantExists) {
            return  sellingPlanId;
          }
        }
      }
    }      

    return null;
  },

  findProductIdWithVariantId: async function (variantId) {
    variantId = Number(variantId);

    this.rechargeProducts = this.rechargeProducts || (await this.getRechargeProducts());

    for (let product of this.rechargeProducts) {
        for (let key in product) {
            let productDetails = product[key];
            if (productDetails.variants && productDetails.variants.some(variant => variant.id === variantId)) {
                return key;
            }
        }
    }
    return null;
  },

  findProductIdWithVariantIdHasSubscription: async function (variantId) {
    variantId = Number(variantId);

    this.rechargeProducts = this.rechargeProducts || (await this.getRechargeProducts());

    for (let product of this.rechargeProducts) {
        for (let key in product) {
            let productDetails = product[key];
            if (productDetails.variants && productDetails.variants.some(variant => variant.id === variantId && variant.selling_plan_allocations.length > 0)) {
                return key;
            }
        }
    }
    return null;
  },

  getTotalQuantityWithBuildABoxDiscount: function () {
    return theme.cartData.items.reduce((totalQuantity, item) => {
      if (item.discounts && item.discounts.some(discount => discount.title.toLowerCase().startsWith("build-a-box"))) {
        return totalQuantity + item.quantity;
      }
      return totalQuantity;
    }, 0);
  },

  getTotalQuantityQualifyBuildABoxDiscount: function () {
    return theme.cartData.items.reduce((totalQuantity, item) => {
      const isProductInBundleCollection = this.bundleCollectionProducts.some(product => product.id === item.product_id);
  
      if (isProductInBundleCollection) {
        return totalQuantity + item.quantity;
      }
  
      return totalQuantity;
    }, 0);
  },

  getTotalQuantityWithSubscription: function () {
    return theme.cartData.items.reduce((totalQuantity, item) => {
      if (item.selling_plan_allocation) {
        return totalQuantity + item.quantity;
      }
      return totalQuantity;
    }, 0);
  },

  oldgetTotalQuantityQualifySubscription: function () {
    if (!theme.cartData){
      return 0;
    }
    return theme.cartData.items.reduce((totalQuantity, item) => {
      if (this.findProductIdWithVariantIdHasSubscription(item.variant_id)) {
        return totalQuantity + item.quantity;
      }
      return totalQuantity;
    }, 0);
  },

  getTotalQuantityQualifySubscription: async function () {
    if (!theme.cartData) {
      return 0;
    }
  
    const totalQuantities = await Promise.all(
      theme.cartData.items.map(async (item) => {
        const productId = await this.findProductIdWithVariantIdHasSubscription(item.variant_id);
        return productId ? item.quantity : 0;
      })
    );
  
    return totalQuantities.reduce((total, quantity) => total + quantity, 0);
  },
  
  getDiscountLevelForItem: function (variantId) {
    const item = this.bundleCollectionProducts.find(product =>
      product.variants.some(variant => variant.id === variantId)
    );

    if (item && item.tags.includes('bab')) {
      const totalQuantity = this.getTotalQuantityWithBuildABoxDiscount();
      return this.discountLevels.reduce((maxDiscount, level) => {
        if (totalQuantity >= level.products) {
          return level.discount;
        }
        return maxDiscount;
      }, 0);
    }

    return 0.0;
  },

  getDiscountLevel: function (levelModifier = 0) {
      const totalQuantity = this.getTotalQuantityQualifyBuildABoxDiscount() + levelModifier;
   
      return this.discountLevels.reduce((maxDiscount, level) => {
        if (totalQuantity >= level.products) {
          var comparePrice = 14.95;
          var rawPrice = 14.95;
          var discount = level.discount;
          
          if (this.subscribeAndSave) {
            rawPrice = rawPrice * (100 - 5) / 100;
          }

          rawPrice = rawPrice * (100 - level.discount) / 100;
          rawPrice = Math.ceil(rawPrice * 1000) / 1000;
          rawPrice = Math.round(rawPrice * 100) / 100;

          const discountPercentage = isFinite((comparePrice - rawPrice) / comparePrice * 100)
          ? Math.round(((comparePrice - rawPrice) / comparePrice) * 100 * 100) / 100
          : 0;
          
          return discountPercentage;
        }
        return maxDiscount;
      }, 0);
  },

  cartChangedItemQuantity: function(item, quantityChange) {
    this.cornerStone.cartChangedItemQuantity(item, quantityChange);
  },

  refreshCart: function() {
      if (!this.rebuySmartCartEnabled)
      {
        this.quickCartInstance.refreshQuickCart();
      }      
  },    

  reshipLastOrder: async function () {
    try {
      // Check if lastOrder exists and has items
      if (!lastOrder || !lastOrder.lineItems || lastOrder.lineItems.length === 0) {
        alert("No items found in the last order. Unable to reship.");
        return;
      }
  
      // Clear the current cart
      const clearCartResponse = await fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: "POST",
        credentials: "include", // You may try removing this if it's not needed
        headers: {
          "Content-Type": "application/json"
        }
      });
  
      if (!clearCartResponse.ok) {
        throw new Error("Failed to clear the cart.");
      }
  
      // Add items from the last order one by one
      for (const item of lastOrder.lineItems) {
        try {
          const addItemResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: item.variantId,
              quantity: item.quantity
            })
          });
  
          if (!addItemResponse.ok) {
            const errorDetails = await addItemResponse.json();
            console.warn(`Failed to add item with variantId ${item.variantId}: ${errorDetails.message}`);
          } else {
            this.debug && console.log(`Item with variantId ${item.variantId} added successfully.`);
          }
        } catch (error) {
          console.warn(`Error adding item with variantId ${item.variantId}: ${error.message}`);
          // Continue with the next item even if one fails
        }
      }
  
      // Redirect to the checkout page after all items are processed
      window.location.href = window.Shopify.routes.root + 'checkout';
    } catch (error) {
      console.error("An error occurred while reshipping the last order:", error);
      alert(error.message);
    }
  },

  cornerStone: {
    init: async function (parentObject) {
      this.parent = parentObject;

      this.productGridSwitch();

      if (!this.parent.rebuySmartCartEnabled) {
        this.quickCart.init(parentObject);
        this.parent.snsButton = "button.quick-cart__submit";
      }

      document.addEventListener("quick-view:loaded", () => {
        this.parent.cornerStone.updateProductQuickView();
      });

      document.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll('input[name="customer[password]"]').forEach((value) => {
            this.parent.cornerStone.passwordShowHide(value);
        });
      });

      document.addEventListener('click', (event) => {
        // Get target element once
        const target = event.target;
        
        // Check if target is a link or contains a link
        const link = target.closest('a[href="/account"], a[href="/account/addresses"]');
        
        // Early return if no matching link
        if (!link) return;
        
        if (this.parent.customDashboard == true) {
          event.preventDefault();
          if (link.getAttribute('href') === '/account/addresses') {
            window.location.href = '/pages/dashboard?section=my-account';
          }
          else {
            window.location.href = '/pages/dashboard';
          }
        }
        else
        {
          // Check customer tags only once
          //const isActiveSubscriber = window.customerTags && 
          //  Array.isArray(window.customerTags) && 
          //  window.customerTags.includes('Active Subscriber');
          const isActiveSubscriber = this.parent.rechargePortalAccess &&
            this.parent.rechargeSubscriptions.length > 0 &&
            angelinos.rechargeSubscriptions.filter(subscription => subscription.status === "active").length > 0;

          if (!isActiveSubscriber) return;
          
          // Prevent default behavior
          event.preventDefault();
          
          // Determine redirect URL based on href
          const portalUrl = this.parent.rechargePortalAccess.portal_url;
          window.location.href = link.getAttribute('href') === '/account/addresses' 
            ? portalUrl.replace("/overview?", "/shipping?")
            : portalUrl;
        }
      });
        
      this.observeCollectionFilterChanges();
      this.observeMobileMenu();
    },    

    productGridSwitch: async function () {
      const dataItemLayout = document.querySelector("section.collection[data-item-layout]");
      const width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
  
      if (dataItemLayout && width < 1024)
      {
        dataItemLayout.setAttribute("data-item-layout", "list");
      }
    },

    passwordShowHide: function(value) {
      // Create a wrapper div and add class
      var wrapper = document.createElement('div');
      wrapper.classList.add('login__password-wrapper');
      
      // Insert the wrapper before the password input field and move the input inside the wrapper
      value.parentNode.insertBefore(wrapper, value);
      wrapper.appendChild(value);  
  
      // Create the toggle-password span and icon element
      var toggleSpan = document.createElement('span');
      toggleSpan.classList.add('toggle-password');
      var toggleIcon = document.createElement('i');
      toggleIcon.classList.add('fa', 'fa-eye');
      toggleIcon.setAttribute('aria-hidden', 'true');
      
      // Append the icon inside the span and the span after the input field
      toggleSpan.appendChild(toggleIcon);
      wrapper.appendChild(toggleSpan);
  
      // Add event listener to toggle password visibility
      toggleSpan.addEventListener('click', function () {
        const isPasswordHidden = value.getAttribute('type') === 'password';
        value.setAttribute('type', isPasswordHidden ? 'text' : 'password');
        toggleIcon.classList.toggle('fa-eye');
        toggleIcon.classList.toggle('fa-eye-slash');
      });
    },
    
    observeCollectionFilterChanges: async function () {
      const collectionFilter = document.querySelector("div#filter-group-category--drawer");
  
      if (collectionFilter) {
        const mutationCallback = (mutationsList) => {
          for (let mutation of mutationsList) {
           if (mutation.type === 'childList' || mutation.type === 'characterData') {
             this.parent.update();
             this.parent.debug && console.log("observeCollectionFilterChanges");
            }
          }
        };
      
        const observer = new MutationObserver(mutationCallback);
        const config = { childList: true, subtree: true, characterData: true };
        observer.observe(collectionFilter, config);
      }
    },     

    observeMobileMenu: async function () {
      const panel = document.querySelector('.mobile-menu__panel');
      if (panel) {
        // We only watch for childList changes in this panel, not the entire body
        const config = { childList: true };
      
        const callback = (mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length) {
              for (const node of mutation.addedNodes) {
                // Check if it's the .mobile-menu__viewport
                if (node.matches && node.matches('.mobile-menu__viewport')) {
                  const accountLinks = node.querySelector('.account-overview__links');
                  if (accountLinks) {
                   if (this.parent.rechargePortalAccess && this.parent.rechargeSubscriptions.length > 0) {  
                     if (this.parent.rechargeSubscriptions.filter(subscription => subscription.status === "active").length == 0) {
                        const aManageSubscription = document.createElement("a"); 
                        aManageSubscription.className = "account-overview__link fs-body-100 recharge-portal-access";
                        aManageSubscription.href = this.parent.rechargePortalAccess.portal_url.replace("/overview?", "/subscriptions?")+"&tab=inactive";
                        aManageSubscription.innerText = 'Reactivate Subscription';
                        aManageSubscription.style.display = "block";
                      
                        const icon = document.createElement("span"); 
                        icon.className = "icon icon-package-closed";
                        const svg = document.createElement("svg"); 
                        svg.setAttribute('viewBox', '-0.5 -0.5 24 24');
                        svg.setAttribute('fill', 'none');
                        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                        
                        icon.append(svg);
                        aManageSubscription.prepend(icon);
                        
                        accountLinks.prepend(aManageSubscription);
                     }
                   }
                  }
      
                  // If you only want to do this once, disconnect the observer:
                  observer.disconnect();
                }
              }
            }
          }
        };
      
        const observer = new MutationObserver(callback);
        observer.observe(panel, config);
      }
    },     

    updateProductQuickView: async function () {
      /* Enhancedments
        can we move const properties = await this.getRCBundleProperties() somewhere else to optimize/consolidate?
        when switching back/forward from sns/one-time need to make sure it updates/removes hidden properties and messaging properly
      */
      const quickView = document.querySelector("div.quick-product-modal");
      const productForm = quickView.querySelector("form");
      const variantId = Number(productForm.getAttribute("data-current-product-id"));
      const productId = Number(productForm.querySelector("input[name='product-id'").value);
      const priceBlocks = quickView.querySelectorAll("div.product__price");
  
      const product = this.parent.bundleCollectionProducts.find(product => 
        product.variants.some(variant => variant.id === variantId)
      );
  
      const variantPrice = await this.parent.getVariantPrice(variantId, productId);
  
      if (variantPrice.price > 0) {
        let hiddenInput = productForm.querySelector("input[name='selling_plan']");
        if (hiddenInput) {
          hiddenInput.value = variantPrice.sellingPlanId;
        } else {
          hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.name = "selling_plan";
          hiddenInput.value = variantPrice.sellingPlanId;
          productForm.appendChild(hiddenInput);
        }
  
        if (variantPrice.isProductInBundleCollection) {
          const properties = this.parent.getRCBundleProperties();
          const propertiesArray = Object.entries(properties);
    
          propertiesArray.forEach(([key, value]) => {
            let propertyInput = productForm.querySelector(`input[name='properties[${key}]']`);
            if (propertyInput) {
              propertyInput.value = value;
            } else {
              propertyInput = document.createElement("input");
              propertyInput.type = "hidden";
              propertyInput.name = `properties[${key}]`;
              propertyInput.value = value;
              productForm.appendChild(propertyInput);
            }
            //console.log(key, value);
          });
        }
        
        priceBlocks.forEach(function(block) {
          const spanPrice = block.querySelector("span[data-price]");
          spanPrice.innerHTML = `$${variantPrice.price.toFixed(2)}`;
  
          if (variantPrice.comparePrice > variantPrice.price) {
            const spanComparePrice = block.querySelector("s[data-compare-price]");
            if (spanComparePrice) { // Check if spanComparePrice is not null
              spanComparePrice.innerHTML = `$${variantPrice.comparePrice.toFixed(2)}`;
            }
            
            const spanDiscount = block.querySelector("span[data-has-discount]");
            if (spanDiscount) { // Check if spanDiscount is not null
              spanDiscount.setAttribute("data-has-discount", "true");
        
              const displayedDiscount = spanDiscount.querySelector("span.displayed-discount");
              if (displayedDiscount) { // Check if displayedDiscount is not null
                displayedDiscount.innerHTML = `${variantPrice.discountPercentage.toFixed(2)}% off`;
              }
            }
          }
        }, this);      
      }
    },
    
    cartChangedItemQuantity: function(item, quantityChange) {
      const productId = item.product_id;
      const variantId = item.variant_id;
  
      this.parent.debug && console.log("changeItemQuantity", productId, variantId, quantityChange);
  
      //Product collections
      document.querySelectorAll('.product-item[data-id="'+productId+'"]').forEach(element => {
        if (element.hasAttribute('data-quantity-in-cart')) {
          // Retrieve the current quantity, default to 0 if not a number
          const currentQuantity = parseInt(element.getAttribute('data-quantity-in-cart'), 10) || 0;
          const newQuantity = currentQuantity + quantityChange;
  
          // Update the attribute with the new quantity (ensure it’s at least 0)
          element.setAttribute('data-quantity-in-cart', Math.max(newQuantity, 0));
        }
  
        element.querySelectorAll('.quantity-input__input[value]').forEach(childElement => {
          //Retrieve the current quantity, default to 0 if not a number
          const currentQuantity = parseInt(childElement.value, 10) || 0;
          const newQuantity = currentQuantity + quantityChange;
  
          // Update the attribute with the new quantity (ensure it’s at least 0)
          childElement.value = Math.max(newQuantity, 0);
        });
  
        element.querySelectorAll('.quantity-in-cart-display[data-id="'+productId+'"]').forEach(childElement => {
          //Retrieve the current quantity, default to 0 if not a number
          const currentQuantity = parseInt(childElement.textContent, 10) || 0;
          const newQuantity = currentQuantity + quantityChange;
    
          // Update the displayed with the new quantity (ensure it’s at least 0)
          childElement.textContent = Math.max(newQuantity, 0);        
        });
        
        element.querySelectorAll('[data-product-id="'+productId+'"][data-quantity-in-cart]').forEach(childElement => {
          // Retrieve the current quantity, default to 0 if not a number
          const currentQuantity = parseInt(childElement.getAttribute('data-quantity-in-cart'), 10) || 0;
          const newQuantity = currentQuantity + quantityChange;
    
          // Update the attribute with the new quantity (ensure it’s at least 0)
          childElement.setAttribute('data-quantity-in-cart', Math.max(newQuantity, 0));
        });
    
        element.querySelectorAll('[data-variant-id="'+variantId+'"][data-quantity-in-cart]').forEach(childElement => {
          // Retrieve the current quantity, default to 0 if not a number
          const currentQuantity = parseInt(childElement.getAttribute('data-quantity-in-cart'), 10) || 0;
          const newQuantity = currentQuantity + quantityChange;
    
          // Update the attribute with the new quantity (ensure it’s at least 0)
          childElement.setAttribute('data-quantity-in-cart', Math.max(newQuantity, 0));
        });    
      });
    },
        
    quickCart: {
      //parent: {},
    
      init: async function (parentObject) {
        this.parent = parentObject;

        this.quickCartFooter();
      },

      quickCartFooter: async function () {
        //if (this.rebuySmartCartEnabled) {
        //  return;
        //}
        if (!document.querySelector("#quick-cart__sas")) {
          // Create the new div element
          var newElement = document.createElement("div");
          newElement.id = "quick-cart__sas";
        
          // Find the quick-cart__footer element
          var quickCartFooter = document.querySelector(".quick-cart__footer");
        
          if (quickCartFooter) {
            // Insert the new element after quick-cart__footer
            quickCartFooter.insertAdjacentElement("afterbegin", newElement);
          
            // Call the function to insert the button
            //this.updateButton();
          }
        }
      }      
    }
  },

  rebuy: {
    //parent: {},
    
    init: async function (parentObject) {
      this.parent = parentObject;

      if (this.parent.rebuySmartCartEnabled) {
        this.smartCart.init(parentObject);
        this.parent.snsButton = ".rebuy-cart__checkout-button";
      }
    },
      
    smartCart: {
        //parent: {},
      
        init: async function (parentObject) {
          this.parent = parentObject;

          document.addEventListener('rebuy:smartcart.ready', (event) => { 
            this.parent.debug && console.log('uy:smartcart.ready event', event.detail); 

            if (window.location.pathname === '/cart') {
              window.location.href = '/collections/build-a-box?viewcart=true';
            } 
          });     

          document.addEventListener('rebuy:cart.change', (event) => { 
            theme.cartData = event.detail.cart.cart;
          
            this.parent.debug && console.log('rebuy:cart.change event', event.detail); 
            if (this.parent.resourcesLoaded) {
              this.parent.update();
            }
          });     
  
          document.addEventListener("rebuy:smartcart.line-item-increase", (event) => {
            const smartcart = event.detail.smartcart;
            const item = event.detail.item;
            
            this.parent.debug && console.log("rebuy:smartcart.line-item-increase: smartcart", smartcart, item);
            this.parent.cartChangedItemQuantity(item, 1);
          });
  
          document.addEventListener("rebuy:smartcart.line-item-decrease", (event) => {
            const smartcart = event.detail.smartcart;
            const item = event.detail.item;
          
            this.parent.debug && console.log("rebuy:smartcart.line-item-decrease smartcart", smartcart, item);
            this.parent.cartChangedItemQuantity(item, -1);
          });
  
          document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
            const smartcart = event.detail.smartcart;
            const item = event.detail.item;
          
            this.parent.debug && console.log("rebuy:smartcart.line-item-removed: smartcart", smartcart, item);
            this.parent.cartChangedItemQuantity(item, -item.quantity);
          });
        }
    }
  }
};

// Generalized polling function to wait for any property to be loaded
function waitForProperty(obj, propertyName, callback) {
  if (typeof obj[propertyName] !== 'undefined' && obj[propertyName] !== null) {
    callback();
  } else {
    setTimeout(() => waitForProperty(obj, propertyName, callback), 100);
  }
}

// Polling function to wait for ReChargeWidget to be loaded
function waitForReChargeWidget(callback) {
  if (typeof ReChargeWidget !== 'undefined') {
    callback();
  } else {
    setTimeout(() => waitForReChargeWidget(callback), 100);
  }
}

// Ensure initialization is called
(async function () {
  await angelinos.init();
  window.angelinos = angelinos;
})();


document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const productId = urlParams.get('product');

    if (productId) {
        const observer = new MutationObserver(function(mutationsList, observer) {
            const productElement = document.querySelector(`[data-id="${productId}"]`);
            if (productElement) {
                // Stop observing once the element is found
                observer.disconnect();

                // Get the height of the sticky header (adjust the selector as needed)
                const header = document.querySelector('.header');
                const headerHeight = header ? header.offsetHeight : 0;

                // Calculate the scroll position with the offset
                const elementPosition = productElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

                // Scroll to the product element with the offset
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });

                // Optionally, highlight the product
                //productElement.style.border = '2px solid red';
            }
        });

        // Start observing the document with the configured parameters
        observer.observe(document.body, { childList: true, subtree: true });
    }
});

<!-- BubbleHouse -->
// Add to merchants customers/account.liquid to inject elements at the top of the Dashboard
//Add to merchants customers/addresses.liquid to inject elements into the customer account profile page
// This code is executed when the user is on the '/account' page
if(location.pathname == '/a/customerhub'){
    // Create an observer to monitor changes in the DOM
    const chElementObserver = new MutationObserver((mutations, obs) => {
        try{
            const accountsHub = document.querySelector('accounts-hub');
            if (accountsHub && accountsHub.shadowRoot) {
              // Make sure to update the ID #element-to-inject with the ID of the element you want to inject from the account page code.
              //var chFindElement = document.querySelector('#element-to-inject');

              var chFindElement= `
            <div id="element-to-inject" style="margin-bottom: 10px;">
              <div style="height: 80vw; max-height: 20px"></div>
              <div>
            <bubblehouse-panel if="logged_in" style="visibility: hidden;">
              <a href="https://angelinos.com/apps/bubblehouse/rewards/" 
                 style="display: block; padding: 25px 20px 25px 30px; background: #343B21; color: #F7F6F2; border-radius: 8px; text-align: left; margin-bottom: 20px; text-decoration: none; margin-left: 10px; margin-right: 10px;">
                <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' height='24' width='24'%3E%3Cpath d='M7.438 1.875 17.563 12 7.438 22.125' stroke='%23F7F6F2' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E" 
                     alt="Carrot Icon" width="25px" height="25px" style="position: absolute; right: 0; margin-top: 20px !important; margin-right: 40px !important"/>
                <h2 style="color: #F7F6F2; margin-top: 0px; margin-bottom: 5px; text-transform: uppercase; font-style: italic; font-family: BrandonGrotesque-BlackItalic !important">
                  My rewards: <bubblehouse-value altkey="points-value" style="font-weight: light; font-style: normal;"></bubblehouse-value>
                </h2>
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <div style="display: flex; align-items: center;">
                    <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 34 33' height='33' width='34'%3E%3Cpath stroke-linecap='round' stroke-width='1.5' stroke='%23F6B752' d='M10.5 25C15 23 17.4908 20.6095 17.8718 20.769C18.9856 21.2353 20.0122 21.9696 21.0256 22.6182C21.1996 22.7295 22.3022 23.5588 22.3022 23.3034C22.3022 22.8163 21.99 22.2708 21.9643 21.7828C21.9126 20.801 21.5539 19.4654 21.157 18.5726C21.0154 18.2539 20.9439 16.9339 21.0538 16.6484C21.1996 16.2691 21.9738 15.9321 22.2646 15.6628C22.636 15.3189 25.9936 12.8151 24.6676 12.6591C23.6144 12.5352 22.4102 12.1523 21.2791 12.1523C20.275 12.1523 19.2249 12.4512 18.7541 11.392C18.5705 10.9788 18.0551 10.457 17.7404 10.1248C17.1264 9.47674 16.9489 8.69991 16.4732 8.01284C15.8535 7.11778 14.7775 8.93627 14.4457 9.53345C13.7416 10.8009 13.1127 13.4112 12.6717 13.4664C11.3001 13.4664 11.6026 13.3894 10.2312 13.3256C9.81814 13.3064 6.75029 12.914 7.30264 13.4664C8.1596 14.3233 9.45721 14.488 10.2688 15.5314C11.3508 16.9226 13.0051 16.739 12.6717 18.5726C12.5867 19.0402 8.62613 24.2608 10.2688 24.9554'%3E%3C/path%3E%3Cpath stroke-linecap='round' stroke-width='1.5' stroke='%23F6B752' d='M24.3301 7.75895C25.0483 7.01196 25.8519 5.56213 26.8644 5.22461'%3E%3C/path%3E%3Cpath stroke-linecap='round' stroke-width='1.5' stroke='%23F6B752' d='M16.3887 4.04121C16.3887 3.00263 16.0508 2.00531 16.0508 1'%3E%3C/path%3E%3Cpath stroke-linecap='round' stroke-width='1.5' stroke='%23F6B752' d='M8.28046 8.0959C7.38992 6.98273 6.41324 6.05972 5.4082 5.05469'%3E%3C/path%3E%3Cpath stroke-linecap='round' stroke-width='1.5' stroke='%23F6B752' d='M5.40752 17.3899C3.91909 17.2411 2.32476 16.728 0.845703 17.221'%3E%3C/path%3E%3Cpath stroke-linecap='round' stroke-width='1.5' stroke='%23F6B752' d='M7.77363 26.8496C6.85027 27.1692 5.29245 28.206 4.73242 29.046'%3E%3C/path%3E%3Cpath stroke-linecap='round' stroke-width='1.5' stroke='%23F6B752' d='M15.8828 28.709C16.4124 29.5034 16.2207 30.8245 16.2207 31.7502'%3E%3C/path%3E%3Cpath stroke-linecap='round' stroke-width='1.5' stroke='%23F6B752' d='M25.1758 26.6816C25.6903 27.2605 26.3677 28.2207 26.6964 28.8781'%3E%3C/path%3E%3Cpath stroke-linecap='round' stroke-width='1.5' stroke='%23F6B752' d='M28.0469 17.7266H32.7776'%3E%3C/path%3E%3C/svg%3E%0A"
                      height="25px" width="25px" style="margin-right: 5px !important;"/>
                    <p style="margin: 0;"><bubblehouse-value altkey="points" style="font: var(--text-font-style) var(--text-font-weight) var(--text-base) / 1.65 var(--text-font-family);"></bubblehouse-value> loyalty points</p>
                  </div>
                </div>
              </a>
            </bubblehouse-panel>
            
                <div style="height: 80vw; max-height: 10px"></div>
            </div>
            </div>
              `;

              // Check if the element with the specified ID is found
              if (chFindElement) {
                  // Locate the target insert location on the dashboard
                  //let chDashInsert = document.querySelector('accounts-hub');
                  const shadowRoot = accountsHub.shadowRoot;
                  let chDashInsert = shadowRoot.querySelector('#ae-holder .widget');

                  // Create a new div to hold the content to be injected
                  let chInjectDiv = document.createElement('div');
                  chInjectDiv.classList.add("chContent-Body-Page-General");
                  chInjectDiv.style = "flex: 1 0 100%;";
                  
                  // Copy the inner HTML from the found element to the new div
                  //chInjectDiv.innerHTML = chFindElement.innerHTML;
                  chInjectDiv.innerHTML = chFindElement;
                  
                  // Insert the new div before the target insert location on the dashboard
                  //chDashInsert.parentNode.insertBefore(chInjectDiv, chDashInsert);
                  chDashInsert.prepend(chInjectDiv);
                  
                  // Disconnect the observer as the operation is complete
                  obs.disconnect();
                  return;
              }
          }
        }catch(e){
            // Log any errors to the console and disconnect the observer
            console.log(e);
            obs.disconnect();
        }
    });
    
    // Start observing the entire document for changes in child elements and their subtrees
    chElementObserver.observe(document, {
        childList: true,
        subtree: true
    });
}

// Okendo cart intercept — delegates to angelinos.addItemById
// Must load after angelinos is defined, before Okendo loads
(function initOkendoCartFix() {
  const OKENDO_SECTIONS = ['cart-notification-product', 'cart-drawer'];
  const _fetch = window.fetch;

  window.fetch = async function (input, init, ...rest) {
    const url = (typeof input === 'string' ? input : input?.url) || '';

    if (url.includes('cart/add.js') && init?.method?.toUpperCase() === 'POST') {
      try {
        const body = JSON.parse(init.body || '{}');
        const items = body.items;

        const isOkendoRequest = items?.length &&
          Array.isArray(body.sections) &&
          OKENDO_SECTIONS.every(s => body.sections.includes(s));

        if (isOkendoRequest) {
          const data = angelinos.addItemById(items[0].id, items[0].quantity || 1);
          init = { ...init, body: JSON.stringify({ ...data, sections: body.sections }) };
        }
      } catch (e) {
        console.warn('[OkendoCartFix]', e);
      }
    }

    return _fetch.call(this, input, init, ...rest);
  };
})();